import { fileManagerRestrictionLocale } from "../../widget/file-manager/locale/zh_CN.js";
import { languagePairLocale } from "../../widget/language-pair/locale/zh_CN.js";
import { calendarLocale } from "../calendar/locale/zh_CN.js";
import { cascaderLocale } from "../cascader/locale/zh_CN.js";
import { datePickerLocale } from "../date-picker/locale/zh_CN.js";
import { emptyLocale } from "../empty/locale/zh_CN.js";
import { paginationLocale } from "../pagination/locale/zh_CN.js";
import { tagSelectorLocale } from "../tag-selector/locale/zh_CN.js";
const locale = {
  locale: "zh-CN",
  global: {
    okText: "确定",
    cancelText: "取消"
  },
  calendar: calendarLocale,
  cascader: cascaderLocale,
  datePicker: datePickerLocale,
  empty: emptyLocale,
  pagination: paginationLocale,
  tagSelector: tagSelectorLocale,
  languagePair: languagePairLocale,
  useFileManager: fileManagerRestrictionLocale
};
export {
  locale as default
};
//# sourceMappingURL=zh_CN.js.map
